import { RenderFunc } from '../types/RenderFunc';

export const renderErvkControlKindDocTargetType: RenderFunc = item => {
  const { newValue, oldValue } = item;

  const stringOldValue = oldValue === 'PERMITTED' ? 'Разрешительный документ' : 'Иной документ';
  const stringNewValue = newValue === 'PERMITTED' ? 'Разрешительный документ' : 'Иной документ';

  return {
    renderedOldValue: stringOldValue,
    renderedNewValue: stringNewValue,
  };
};
